import { AluminiumAISampleComposition, SpecificationListItem } from 'api';
import { translate } from 'i18n';

import { formatWeightFeature } from '../formatFeature/formatFeature';
import { formatWeightFeatureWithWarning } from '../formatWeightFeatureWithWarning/formatWeightFeatureWithWarning';

export const formatAluAiLooseComposition = (
  aluAiSampleComposition: AluminiumAISampleComposition,
  totalWeight: number,
  instructions?: SpecificationListItem[]
) => {
  const aluTotal =
    aluAiSampleComposition.ubc +
    aluAiSampleComposition.foil_and_tray +
    aluAiSampleComposition.food_can +
    aluAiSampleComposition.other_aluminium +
    aluAiSampleComposition.aluminium_aerosol;
  const nonAluTotal = aluAiSampleComposition.other_metal + aluAiSampleComposition.non_metal;

  return {
    aluminium: {
      label: translate('backlog.breakdowns.materialLabels.aluminium', { namespace: 'features' }),
      ...formatWeightFeature(aluTotal * totalWeight, totalWeight),
    },
    aluminiumAerosol: {
      label: translate('backlog.breakdowns.materialLabels.aluminiumAerosol', { namespace: 'features' }),
      ...formatWeightFeatureWithWarning(
        'aluminium_aerosol',
        formatWeightFeature(aluAiSampleComposition.aluminium_aerosol * totalWeight, totalWeight),
        instructions
      ),
    },
    foilAndTray: {
      label: translate('backlog.breakdowns.materialLabels.foilAndTray', { namespace: 'features' }),
      ...formatWeightFeatureWithWarning(
        'foil_and_tray',
        formatWeightFeature(aluAiSampleComposition.foil_and_tray * totalWeight, totalWeight),
        instructions
      ),
    },
    foodCans: {
      label: translate('backlog.breakdowns.materialLabels.aluminiumFoodCan', { namespace: 'features' }),
      ...formatWeightFeatureWithWarning(
        'food_can',
        formatWeightFeature(aluAiSampleComposition.food_can * totalWeight, totalWeight),
        instructions
      ),
    },
    nonAluminium: {
      label: translate('backlog.breakdowns.materialLabels.nonAluminium', { namespace: 'features' }),
      ...formatWeightFeature(nonAluTotal * totalWeight, totalWeight),
    },
    nonMetal: {
      label: translate('backlog.breakdowns.materialLabels.nonMetal', { namespace: 'features' }),
      ...formatWeightFeatureWithWarning(
        'non_metal',
        formatWeightFeature(aluAiSampleComposition.non_metal * totalWeight, totalWeight),
        instructions
      ),
    },
    otherAluminium: {
      label: translate('backlog.breakdowns.materialLabels.otherAluminium', { namespace: 'features' }),
      ...formatWeightFeatureWithWarning(
        'other_aluminium',
        formatWeightFeature(aluAiSampleComposition.other_aluminium * totalWeight, totalWeight),
        instructions
      ),
    },
    otherMetal: {
      label: translate('backlog.breakdowns.materialLabels.otherMetal', { namespace: 'features' }),
      ...formatWeightFeatureWithWarning(
        'other_metal',
        formatWeightFeature(aluAiSampleComposition.other_metal * totalWeight, totalWeight),
        instructions
      ),
    },
    total: {
      label: translate('backlog.breakdowns.materialLabels.total', { namespace: 'features' }),
      ...formatWeightFeature(totalWeight, totalWeight),
    },
    ubc: {
      label: translate('backlog.breakdowns.materialLabels.ubc', { namespace: 'features' }),
      ...formatWeightFeatureWithWarning(
        'ubc',
        formatWeightFeature(aluAiSampleComposition.ubc * totalWeight, totalWeight),
        instructions
      ),
    },
  };
};
